import {  Controller,
  Delete,
  Get,
  Param,
  Post,
  Query,
  Req,
  UseGuards,
} from '@nestjs/common';
import { AuthGuard, GuardedRequest } from '../auth/auth.guard';
import { DemoModeGuard } from '../auth/demo-mode.guard';
import { PlatformService } from './platform.service';

@Controller('platform/roles')
@UseGuards(AuthGuard, DemoModeGuard)
export class RolesController {
  constructor(private readonly platformService: PlatformService) {}

  @Get()
  listRoles(@Query('scope') scope?: string) {
    return this.platformService.listRoles(scope);
  }

  @Get(':roleId')
  getRole(@Param('roleId') roleId: string) {
    return this.platformService.getRoleWithPermissions(roleId);
  }

  @Post(':roleId/permissions/:permissionId')
  assignPermission(
    @Param('roleId') roleId: string,
    @Param('permissionId') permissionId: string,
    @Req() req: GuardedRequest
  ) {
    return this.platformService.assignPermissionToRole(roleId, permissionId, req.user.id);
  }

  @Delete(':roleId/permissions/:permissionId')
  revokePermission(
    @Param('roleId') roleId: string,
    @Param('permissionId') permissionId: string,
    @Req() req: GuardedRequest
  ) {
    return this.platformService.revokePermissionFromRole(roleId, permissionId, req.user.id);
  }
}
